import styles from './SecondMenu.module.css'
import iconGeo from '../Img/icon_geo.png'
import iconLK from '../Img/icon_lk.png'
import {useDispatch, useSelector} from "react-redux";
import {
    ActionMessageInt,
    ReduxStateInt, setAuthLogin,
    setAuthToken,
    setBaseRegion,
    setLoginState, setSlider,
    setTfFilter, setXFilterValue
} from "../Reducer/GlobalReducer";
import React, {useEffect, useRef, useState} from "react";
import ModalWindow from "../FormTemplate/ModalWindow/ModalWindow";
import LoginForm from "../Auth/LoginForm/LoginForm";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import RegionChange from "../RegionChange/RegionChange";
import useApiQuery, {ApiQueryResponse} from "../ApiQuery/UseApiQuery";
import {useIsMobile} from "../Util/CheckMobile";
import {Subscription} from "rxjs";

export const SecondMenuContext = React.createContext<any | undefined>(undefined);
interface XFilterInt
{
    name:string
    val:string
    type?:number
    selected:boolean

}

function SecondMenu()
{

    const rxObserve = useSelector((state: ReduxStateInt) => {
        return state.rxObserve
    })
    const prefDomain = useSelector((state: ReduxStateInt) => {
        return state.prefDomain
    })

    const xFilterRef = useRef<HTMLDivElement>(null)
    const mobileMode = useSelector((state: ReduxStateInt) => {
        return state.mobileMode
    })


    const refMainFilter = useRef<HTMLDivElement>(null)


    const xFilterRedux = useSelector((state:ReduxStateInt)  => {return state.xFilter} )
    const tfFilter = useSelector((state:ReduxStateInt)  => {return state.tarifFilter} )

    const tarifXFilterData = useRef()
    const [ldrTarifXFilter, rsTarifXFilter, exTarifXFilter] = useApiQuery("/ref/tarif/xfilter","get",tarifXFilterData)
    const [xFilter, setXfilter] = useState<XFilterInt[]>([])
    const [xFilterChunked, setXfilterChunked] = useState<XFilterInt[][]>([])

    const isMobile = useIsMobile()

//    const [chunkCount] = useState(isMobile ? 2: 1)
    const [chunkCount, setChunkCount] = useState(1)

    const path = useLocation()


    const dispatch = useDispatch();

    const baseRegion = useSelector((state:ReduxStateInt)  => {return state.baseRegion});

    const tarifFilter = useSelector((state:ReduxStateInt)  => {return state.tarifFilter});

    const navigate = useNavigate();
    const location = useLocation()


    const [sticky, setSticky] = useState(false)
    const [marginXFilter, setMarginXFilter] = useState(0)
    const subscriber = useRef<Subscription>()

    const [scroll, setScroll] = useState(0);

    const isRegionChanged = useSelector((state:ReduxStateInt)  => {return state.baseRegion.isChanged})
    const isLogin =  useSelector((state:ReduxStateInt)  => {return state.isLogin})
    const authUser =  useSelector((state:ReduxStateInt)  => {return state.authLogin})


    const bgColor = ['#ebffed','#f2f3f5','#f5f1ff','#ecf9ff','#fcf6d7','#ffefef','#f2edff']



    useEffect(()=>{
        if(subscriber.current)
        {
            try {
                subscriber.current?.unsubscribe()
            } catch (e) {

            }
        }
        //console.log(`Slider ${id.current} add subscriber`)
        subscriber.current = rxObserve.subscribe((e)=>messageMake(e))
        return ()=>{
            //console.log(`Slider ${id.current} remove subscriber`)
            if(subscriber.current)subscriber.current?.unsubscribe()
        }
    })


    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);



    useEffect(()=>{
        if(!xFilterRedux?.active)
        {
            resetXFilter()
        }
    },[xFilterRedux])

    useEffect(()=>{
        exTarifXFilter().then((e)=>{
            if(e?.success)
            {
                setXfilter(e?.payload?.map( (item:any) =>{
                    return {...item, selected: false}
                } ))

            }
        })
    },[tarifXFilterData])

    useEffect(()=>{
        if(isMobile)setChunkCount(2)
        else setChunkCount(1)
    },[isMobile])

    useEffect(()=>{
        if(xFilter.length)setXfilterChunked(chunkArray(xFilter,chunkCount))

    },[chunkCount,xFilter])


    const chunkArray = (arr:any[],chunkSize=2) =>{
        const result=[];
        for(let i=0; i<arr.length; i+=chunkSize) {
            result.push(arr.slice(i,i+chunkSize));
        }
        return result;
    }



    const messageMake = (message: ActionMessageInt) =>{
        if(message?.message?.match(/xFilter-stick/ui))
        {
            if(! isMobile) return;
            setSticky(true)

            return
        }
        if(message?.message?.match(/xFilter-normal/ui))
        {
            if(! isMobile) return;
            setSticky(false)
            return

        }

        if(message?.message?.match(/btMenu-filter/ui))
        {
            handleFilter()
        }

        if(message?.message?.match(/mainFilter-view/ui))
        {
            if(refMainFilter.current)refMainFilter.current.scrollIntoView()
        }



    }


    const handleScroll = () => {
        setScroll(window.scrollY);

    }
    useEffect(()=>{
        if(sticky && isMobile)window.scrollTo(0,0)

    },[xFilterRedux.val])



    const buildXFilterLine = () =>{
        const x = xFilterChunked.map((item,idx)=>{
            return(
                <div key={idx} className={styles.xFilterLine}>
                    {buildXFilter(item,idx)}
                </div>
            )
        })
        return x
    }

    const resetXFilter = () =>{
        //console.log("2",xFilterChunked)
        const x = xFilterChunked?.map((item,idv)=>{
            return item?.map((itm,id)=>{
                itm.selected = false
                return itm
            })

        })
        //console.log(x)
        setXfilterChunked(x)

    }

    const setSelected = (_idx:number, _line:number) => {
        const x = xFilterChunked?.map((item,idv)=>{
            return item?.map((itm,id)=>{
                if(idv === _line && id === _idx) {
                    itm.selected = !itm.selected
                    dispatch(setXFilterValue({
                        val: itm?.selected ? itm.val : "",
                        active : true
                    }))
                    rxObserve.next({
                        message: itm?.selected ?  "xFilter-make" : "xFilter-reset",
                        data: {
                            val:itm?.selected ? itm.val : undefined,
                        }
                    })



                }
                else                 itm.selected = false
                return itm
            })

        })
        setXfilterChunked(x)
    }


    const buildXFilter = (data:XFilterInt[], line:number) =>{
        const len = data?.length
        const bgLen = bgColor.length
        const x =data?.map((item,idx)=>{
            return(
                    <div key={idx} className={[styles.baseOption, styles.xFilter, idx < len-1 ? styles.lmar : "",item?.selected ? styles.xFilterHover : ""].join(' ')}
                         style={{backgroundColor: bgColor[(line +idx) % bgLen] }}

                         onClick={  () =>
                         {
                             setSelected(idx,line)
                         }}
                    >
                        <i className='bx bx-memory-card'></i>
                        {item?.type === 1 && <i className={['bx bx-infinite',styles.unX].join(' ')}></i>}
                        <span>{item?.name}</span>
                    </div>
            )

        })
        return x
    }


    const handleFilter = () =>{
        const x = tarifFilter?.active
        if(x) resetXFilter()
        dispatch(setTfFilter(
            {...tarifFilter,
                //active:!tarifFilter.active,
                active: !x
            }))
        dispatch(setSlider({sliderMode:0}))
        if(mobileMode){


        }


        //navigate('/')

    }


    return(
        <div className={styles.secondMenu}>
            <div className={styles.secondMenuContainer}>

                { prefDomain?.showMainFilter &&
                    <div className={[styles.baseOption, styles.catalog,styles.plBox].join(' ')} ref={refMainFilter}
                         onClick={  handleFilter}

                    >
                        <i className='bx bx-filter-alt'></i>
                        <span>фильтр</span>
                    </div>


                }


                {
                    !tfFilter?.active && prefDomain.showXFilter &&
                    <div className={styles.xFilterMain} >
                        <div className={[styles.xFilterCont, sticky ? styles.sticky : ""].join(' ')} ref={xFilterRef} >
                            {buildXFilterLine()}
                        </div>

                    </div>
                }
                {
                    tfFilter?.active &&
                    <div className={[styles.xFilterMain, styles.xFilterTitle].join(' ')}>Фильтр тарифов</div>
                }
                {
                    !tfFilter?.active && isMobile && prefDomain?.showReview &&
                    <div className={styles.rvCont}
                        onClick={()=>{
                            rxObserve.next({
                                message:"moveToReview"
                            })

                        }}
                    >
                        отзывы о нас
                    </div>
                }

            </div>

        </div>
    );
}
export default SecondMenu